import React from "react";
import { Route, Routes } from "react-router-dom";
// import SuperadminCommissary from "../components/superadmin";
import SuperadminAccount from "../components/superadmin/account";
import SuperadminCommissary from "../components/superadmin/commissary";
import SuperadminConfigs from "../components/superadmin/configs";
import SuperadminMerchants from "../components/superadmin/merchant";
import NotFound from "../utils/NotFound";
import Poster from "../components/welcome/Poster";

const SuperAdminRoute = () => {
  return (
    <>
      <React.Fragment>
        <Routes>
          <Route hidden path="/" element={<SuperadminCommissary />} />
          <Route hidden path="/merchant" element={<SuperadminMerchants />} />
          <Route hidden path="/configs" element={<SuperadminConfigs />} />
          <Route hidden path="/account" element={<SuperadminAccount />} />
          <Route hidden path="/poster-1" element={<Poster />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </React.Fragment>
    </>
  );
};

export default SuperAdminRoute;
